<template>
<v-container>
<v-data-table
    :items="contracts?.contracts"
    :headers="headers"
    :options.sync="options"
    :server-items-length="contracts?.total"
    style="width: 100%"
    dense
>
<template v-slot:top>
    <v-row>
        <v-col>
            <v-text-field
                label="phone"
                v-model="options.phone"
            ></v-text-field>

        </v-col>
    </v-row>
</template>
</v-data-table>
</v-container>
</template>
<script>
import gql from 'graphql-tag'
export default {
    name: 'ContractManager',
    data() {
        return {
            options: {
                page: 1,
                itemsPerPage: 10,
            },
            headers: [
                {
                    text: 'ID',
                    value: 'id'
                },
                {
                    text: 'number',
                    value: 'phone'
                },
                {
                    text: 'expired',
                    value: 'expired'
                }

            ]
        }
    },
    apollo: {
        contracts: {
            query: gql`
                query Contracts($limit: Int, $offset: Int, $phone: String) {
                    contracts(limit: $limit, offset: $offset, phone: $phone) {
                        total
                        contracts {
                        id
                        phone
                        expired
                        }
                    }
            }`,
            variables: function() { return {
                limit: this.options.itemsPerPage,
                offset: (this.options.page-1) * this.options.itemsPerPage,
                phone: this.options.phone
            }},
            fetchPolicy: 'no-cache',
        }
    }
}
</script>